import { Directive, HostListener, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[appDisplay]',
})
export class DisplayDirective {
  @HostBinding('class.open') isOpen = false;
  @HostListener('keyup.tab')
  toggle() {
    this.isOpen = true;
  }

  @HostListener('click', ['$event'])
  @HostListener('keyup.enter', ['$event'])
  toggleOpen(e) {
    const parentClass = [...e.target.parentNode.classList];
    e.target.parentNode.classList.toggle('open');
  }
}
